import React from "react";
import { useMediaQuery } from "react-responsive";

export default function PlayAviatrix() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="container-fluid custom-padding games-section">
      <div
        className="text-center d-flex flex-column justify-content-center align-items-center"
        style={{
          minHeight: isMobile ? "50vh" : "60vh",
          padding: "4rem 1rem",
        }}
      >
        <h2 className="mb-3" style={{ color: "#FAE26A" }}>
          Coming Soon
        </h2>
        <p className="text--medium text--light mb-0 px-3">
          Aviatrix is not available yet. Please check back later.
        </p>
      </div>
    </div>
  );
}
